import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Emergency Procedures questions
export const emergencyProceduresMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-ep-1',
    text: {
      en: 'What should you do if you are involved in a traffic accident?',
      nl: 'Wat moet je doen als je betrokken bent bij een verkeersongeval?',
      ar: 'ماذا يجب أن تفعل إذا كنت متورطا في حادث مرور؟'
    },
    options: [
      {
        id: 'q-ep-1o1',
        text: {
          en: 'Drive away quickly',
          nl: 'Rijd snel weg',
          ar: 'اذهب بسرعة'
        }
      },
      {
        id: 'q-ep-1o2',
        text: {
          en: 'Stop immediately and check for injuries',
          nl: 'Stop onmiddellijk en controleer op verwondingen',
          ar: 'توقف فورا وتحقق من الإصابات'
        }
      },
      {
        id: 'q-ep-1o3',
        text: {
          en: 'Wait for someone else to call the police',
          nl: 'Wacht tot iemand anders de politie belt',
          ar: 'انتظر حتى يتصل شخص آخر بالشرطة'
        }
      }
    ],
    correctAnswerId: 'q-ep-1o2',
    explanation: {
      en: 'If you are involved in a traffic accident, you must stop immediately and check for injuries. Call emergency services if needed.',
      nl: 'Als je betrokken bent bij een verkeersongeval, moet je onmiddellijk stoppen en controleren op verwondingen. Bel hulpdiensten indien nodig.',
      ar: 'إذا كنت متورطا في حادث مرور، يجب عليك التوقف فورا والتحقق من الإصابات. اتصل بخدمات الطوارئ إذا لزم الأمر.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-2',
    text: {
      en: 'What is the emergency number in the Netherlands?',
      nl: 'Wat is het noodnummer in Nederland?',
      ar: 'ما هو رقم الطوارئ في هولندا؟'
    },
    options: [
      {
        id: 'q-ep-2o1',
        text: {
          en: '911',
          nl: '911',
          ar: '911'
        }
      },
      {
        id: 'q-ep-2o2',
        text: {
          en: '112',
          nl: '112',
          ar: '112'
        }
      },
      {
        id: 'q-ep-2o3',
        text: {
          en: '999',
          nl: '999',
          ar: '999'
        }
      }
    ],
    correctAnswerId: 'q-ep-2o2',
    explanation: {
      en: 'The emergency number in the Netherlands is 112. This number connects you to police, fire, and ambulance services.',
      nl: 'Het noodnummer in Nederland is 112. Dit nummer verbindt je met politie, brandweer en ambulancediensten.',
      ar: 'رقم الطوارئ في هولندا هو 112. هذا الرقم يربطك بالشرطة والإطفاء وخدمات الإسعاف.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-3',
    text: {
      en: 'When should you call the emergency number 112?',
      nl: 'Wanneer moet je het noodnummer 112 bellen?',
      ar: 'متى يجب أن تتصل برقم الطوارئ 112؟'
    },
    options: [
      {
        id: 'q-ep-3o1',
        text: {
          en: 'Only for life-threatening situations',
          nl: 'Alleen voor levensbedreigende situaties',
          ar: 'فقط للحالات المهددة للحياة'
        }
      },
      {
        id: 'q-ep-3o2',
        text: {
          en: 'For any traffic accident',
          nl: 'Voor elk verkeersongeval',
          ar: 'لأي حادث مرور'
        }
      },
      {
        id: 'q-ep-3o3',
        text: {
          en: 'For life-threatening situations and serious accidents',
          nl: 'Voor levensbedreigende situaties en ernstige ongevallen',
          ar: 'للحالات المهددة للحياة والحوادث الخطيرة'
        }
      }
    ],
    correctAnswerId: 'q-ep-3o3',
    explanation: {
      en: 'Call 112 for life-threatening situations and serious accidents where immediate assistance is needed.',
      nl: 'Bel 112 voor levensbedreigende situaties en ernstige ongevallen waar onmiddellijke hulp nodig is.',
      ar: 'اتصل بـ 112 للحالات المهددة للحياة والحوادث الخطيرة التي تحتاج إلى مساعدة فورية.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-4',
    text: {
      en: 'What should you do if you witness a traffic accident?',
      nl: 'Wat moet je doen als je getuige bent van een verkeersongeval?',
      ar: 'ماذا يجب أن تفعل إذا شهدت حادث مرور؟'
    },
    options: [
      {
        id: 'q-ep-4o1',
        text: {
          en: 'Continue driving',
          nl: 'Blijf rijden',
          ar: 'استمر في القيادة'
        }
      },
      {
        id: 'q-ep-4o2',
        text: {
          en: 'Stop and offer assistance if safe to do so',
          nl: 'Stop en bied hulp aan als het veilig is',
          ar: 'توقف وعرض المساعدة إذا كان ذلك آمنا'
        }
      },
      {
        id: 'q-ep-4o3',
        text: {
          en: 'Call the police immediately',
          nl: 'Bel onmiddellijk de politie',
          ar: 'اتصل بالشرطة فورا'
        }
      }
    ],
    correctAnswerId: 'q-ep-4o2',
    explanation: {
      en: 'If you witness a traffic accident, stop and offer assistance if it is safe to do so. Call emergency services if needed.',
      nl: 'Als je getuige bent van een verkeersongeval, stop en bied hulp aan als het veilig is. Bel hulpdiensten indien nodig.',
      ar: 'إذا شهدت حادث مرور، توقف وعرض المساعدة إذا كان ذلك آمنا. اتصل بخدمات الطوارئ إذا لزم الأمر.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-5',
    text: {
      en: 'What should you do if your vehicle breaks down on a motorway?',
      nl: 'Wat moet je doen als je voertuig pech krijgt op een snelweg?',
      ar: 'ماذا يجب أن تفعل إذا تعطلت سيارتك على طريق سريع؟'
    },
    options: [
      {
        id: 'q-ep-5o1',
        text: {
          en: 'Stay in your vehicle',
          nl: 'Blijf in je voertuig',
          ar: 'ابق في سيارتك'
        }
      },
      {
        id: 'q-ep-5o2',
        text: {
          en: 'Get out and stand behind the barrier',
          nl: 'Stap uit en ga achter de vangrail staan',
          ar: 'اخرج ووقف خلف الحاجز'
        }
      },
      {
        id: 'q-ep-5o3',
        text: {
          en: 'Walk along the motorway to find help',
          nl: 'Loop langs de snelweg om hulp te zoeken',
          ar: 'امش على طول الطريق السريع للبحث عن المساعدة'
        }
      }
    ],
    correctAnswerId: 'q-ep-5o2',
    explanation: {
      en: 'If your vehicle breaks down on a motorway, get out and stand behind the safety barrier. Use emergency phones to call for assistance.',
      nl: 'Als je voertuig pech krijgt op een snelweg, stap uit en ga achter de vangrail staan. Gebruik noodtelefoons om hulp te bellen.',
      ar: 'إذا تعطلت سيارتك على طريق سريع، اخرج ووقف خلف الحاجز الأمني. استخدم هواتف الطوارئ للاتصال للمساعدة.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-6',
    text: {
      en: 'What should you do if you see an emergency vehicle with lights and sirens?',
      nl: 'Wat moet je doen als je een hulpdienstvoertuig ziet met lichten en sirenes?',
      ar: 'ماذا يجب أن تفعل إذا رأيت مركبة طوارئ بأضواء وصافرات؟'
    },
    options: [
      {
        id: 'q-ep-6o1',
        text: {
          en: 'Ignore it and continue driving',
          nl: 'Negeer het en blijf rijden',
          ar: 'تجاهله واستمر في القيادة'
        }
      },
      {
        id: 'q-ep-6o2',
        text: {
          en: 'Move to the right and slow down',
          nl: 'Ga naar rechts en vertraag',
          ar: 'انتقل إلى اليمين وأبطئ'
        }
      },
      {
        id: 'q-ep-6o3',
        text: {
          en: 'Speed up to get out of the way',
          nl: 'Versnel om uit de weg te gaan',
          ar: 'اسرع للخروج من الطريق'
        }
      }
    ],
    correctAnswerId: 'q-ep-6o2',
    explanation: {
      en: 'If you see an emergency vehicle with lights and sirens, move to the right and slow down to allow it to pass safely.',
      nl: 'Als je een hulpdienstvoertuig ziet met lichten en sirenes, ga naar rechts en vertraag om het veilig te laten passeren.',
      ar: 'إذا رأيت مركبة طوارئ بأضواء وصافرات، انتقل إلى اليمين وأبطئ للسماح لها بالمرور بأمان.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-7',
    text: {
      en: 'What should you do if you are involved in a minor accident with no injuries?',
      nl: 'Wat moet je doen als je betrokken bent bij een klein ongeval zonder verwondingen?',
      ar: 'ماذا يجب أن تفعل إذا كنت متورطا في حادث بسيط بدون إصابات؟'
    },
    options: [
      {
        id: 'q-ep-7o1',
        text: {
          en: 'Exchange information with the other driver',
          nl: 'Wissel informatie uit met de andere bestuurder',
          ar: 'تبادل المعلومات مع السائق الآخر'
        }
      },
      {
        id: 'q-ep-7o2',
        text: {
          en: 'Call the police immediately',
          nl: 'Bel onmiddellijk de politie',
          ar: 'اتصل بالشرطة فورا'
        }
      },
      {
        id: 'q-ep-7o3',
        text: {
          en: 'Drive away quickly',
          nl: 'Rijd snel weg',
          ar: 'اذهب بسرعة'
        }
      }
    ],
    correctAnswerId: 'q-ep-7o1',
    explanation: {
      en: 'In a minor accident with no injuries, exchange information with the other driver including names, addresses, and insurance details.',
      nl: 'Bij een klein ongeval zonder verwondingen moet je informatie uitwisselen met de andere bestuurder, inclusief namen, adressen en verzekeringsgegevens.',
      ar: 'في حادث بسيط بدون إصابات، قم بتبادل المعلومات مع السائق الآخر بما في ذلك الأسماء والعناوين وتفاصيل التأمين.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-8',
    text: {
      en: 'What should you do if you hit a parked car?',
      nl: 'Wat moet je doen als je een geparkeerde auto raakt?',
      ar: 'ماذا يجب أن تفعل إذا اصطدمت بسيارة متوقفة؟'
    },
    options: [
      {
        id: 'q-ep-8o1',
        text: {
          en: 'Leave a note with your contact information',
          nl: 'Laat een briefje achter met je contactgegevens',
          ar: 'اترك ملاحظة مع معلومات الاتصال الخاصة بك'
        }
      },
      {
        id: 'q-ep-8o2',
        text: {
          en: 'Wait for the owner to return',
          nl: 'Wacht tot de eigenaar terugkomt',
          ar: 'انتظر حتى يعود المالك'
        }
      },
      {
        id: 'q-ep-8o3',
        text: {
          en: 'Call the police immediately',
          nl: 'Bel onmiddellijk de politie',
          ar: 'اتصل بالشرطة فورا'
        }
      }
    ],
    correctAnswerId: 'q-ep-8o1',
    explanation: {
      en: 'If you hit a parked car, leave a note with your contact information and report the incident to your insurance company.',
      nl: 'Als je een geparkeerde auto raakt, laat een briefje achter met je contactgegevens en meld het incident bij je verzekeringsmaatschappij.',
      ar: 'إذا اصطدمت بسيارة متوقفة، اترك ملاحظة مع معلومات الاتصال الخاصة بك وأبلغ عن الحادث لشركة التأمين الخاصة بك.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-9',
    text: {
      en: 'What should you do if you are involved in an accident with a cyclist or pedestrian?',
      nl: 'Wat moet je doen als je betrokken bent bij een ongeval met een fietser of voetganger?',
      ar: 'ماذا يجب أن تفعل إذا كنت متورطا في حادث مع راكب دراجة أو مشاة؟'
    },
    options: [
      {
        id: 'q-ep-9o1',
        text: {
          en: 'Drive away quickly',
          nl: 'Rijd snel weg',
          ar: 'اذهب بسرعة'
        }
      },
      {
        id: 'q-ep-9o2',
        text: {
          en: 'Stop immediately and call emergency services',
          nl: 'Stop onmiddellijk en bel hulpdiensten',
          ar: 'توقف فورا واتصل بخدمات الطوارئ'
        }
      },
      {
        id: 'q-ep-9o3',
        text: {
          en: 'Wait for someone else to help',
          nl: 'Wacht tot iemand anders helpt',
          ar: 'انتظر حتى يساعد شخص آخر'
        }
      }
    ],
    correctAnswerId: 'q-ep-9o2',
    explanation: {
      en: 'If you are involved in an accident with a cyclist or pedestrian, stop immediately and call emergency services (112).',
      nl: 'Als je betrokken bent bij een ongeval met een fietser of voetganger, stop onmiddellijk en bel hulpdiensten (112).',
      ar: 'إذا كنت متورطا في حادث مع راكب دراجة أو مشاة، توقف فورا واتصل بخدمات الطوارئ (112).'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-10',
    text: {
      en: 'What should you do if your vehicle catches fire?',
      nl: 'Wat moet je doen als je voertuig vlam vat?',
      ar: 'ماذا يجب أن تفعل إذا اشتعلت النار في سيارتك؟'
    },
    options: [
      {
        id: 'q-ep-10o1',
        text: {
          en: 'Try to put out the fire yourself',
          nl: 'Probeer de brand zelf te blussen',
          ar: 'حاول إطفاء الحريق بنفسك'
        }
      },
      {
        id: 'q-ep-10o2',
        text: {
          en: 'Stop immediately and evacuate everyone',
          nl: 'Stop onmiddellijk en evacueer iedereen',
          ar: 'توقف فورا وأخل الجميع'
        }
      },
      {
        id: 'q-ep-10o3',
        text: {
          en: 'Continue driving to find help',
          nl: 'Blijf rijden om hulp te zoeken',
          ar: 'استمر في القيادة للبحث عن المساعدة'
        }
      }
    ],
    correctAnswerId: 'q-ep-10o2',
    explanation: {
      en: 'If your vehicle catches fire, stop immediately and evacuate everyone from the vehicle. Call emergency services and move to a safe distance.',
      nl: 'Als je voertuig vlam vat, stop onmiddellijk en evacueer iedereen uit het voertuig. Bel hulpdiensten en ga naar een veilige afstand.',
      ar: 'إذا اشتعلت النار في سيارتك، توقف فورا وأخل الجميع من السيارة. اتصل بخدمات الطوارئ وانتقل إلى مسافة آمنة.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-11',
    text: {
      en: 'What should you do if you witness a hit-and-run accident?',
      nl: 'Wat moet je doen als je getuige bent van een doorrijdongeval?',
      ar: 'ماذا يجب أن تفعل إذا شهدت حادث هرب؟'
    },
    options: [
      {
        id: 'q-ep-11o1',
        text: {
          en: 'Follow the fleeing vehicle',
          nl: 'Volg het vluchtende voertuig',
          ar: 'اتبع المركبة الهاربة'
        }
      },
      {
        id: 'q-ep-11o2',
        text: {
          en: 'Call the police and provide details',
          nl: 'Bel de politie en geef details door',
          ar: 'اتصل بالشرطة وقدم التفاصيل'
        }
      },
      {
        id: 'q-ep-11o3',
        text: {
          en: 'Ignore it',
          nl: 'Negeer het',
          ar: 'تجاهله'
        }
      }
    ],
    correctAnswerId: 'q-ep-11o2',
    explanation: {
      en: 'If you witness a hit-and-run accident, call the police and provide as many details as possible about the fleeing vehicle.',
      nl: 'Als je getuige bent van een doorrijdongeval, bel de politie en geef zoveel mogelijk details door over het vluchtende voertuig.',
      ar: 'إذا شهدت حادث هرب، اتصل بالشرطة وقدم أكبر قدر ممكن من التفاصيل حول المركبة الهاربة.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-12',
    text: {
      en: 'What should you do if you are involved in an accident with an uninsured driver?',
      nl: 'Wat moet je doen als je betrokken bent bij een ongeval met een onverzekerde bestuurder?',
      ar: 'ماذا يجب أن تفعل إذا كنت متورطا في حادث مع سائق غير مؤمن عليه؟'
    },
    options: [
      {
        id: 'q-ep-12o1',
        text: {
          en: 'Accept cash payment',
          nl: 'Accepteer contante betaling',
          ar: 'اقبل الدفع نقدا'
        }
      },
      {
        id: 'q-ep-12o2',
        text: {
          en: 'Call the police and your insurance company',
          nl: 'Bel de politie en je verzekeringsmaatschappij',
          ar: 'اتصل بالشرطة وشركة التأمين الخاصة بك'
        }
      },
      {
        id: 'q-ep-12o3',
        text: {
          en: 'Drive away quickly',
          nl: 'Rijd snel weg',
          ar: 'اذهب بسرعة'
        }
      }
    ],
    correctAnswerId: 'q-ep-12o2',
    explanation: {
      en: 'If you are involved in an accident with an uninsured driver, call the police and your insurance company immediately.',
      nl: 'Als je betrokken bent bij een ongeval met een onverzekerde bestuurder, bel onmiddellijk de politie en je verzekeringsmaatschappij.',
      ar: 'إذا كنت متورطا في حادث مع سائق غير مؤمن عليه، اتصل بالشرطة وشركة التأمين الخاصة بك فورا.'
    },
    subject: 'Emergency Procedures'
  }
  ,
  {
    id: 'q-ep-13',
    text: {
      en: 'What should you do if your vehicle suddenly loses brake pressure while driving?',
      nl: 'Wat moet je doen als je voertuig tijdens het rijden plotseling geen remdruk meer heeft?',
      ar: 'ماذا يجب أن تفعل إذا فقدت سيارتك فجأة ضغط الفرامل أثناء القيادة؟'
    },
    options: [
      {
        id: 'q-ep-13o1',
        text: {
          en: 'Pump the brake pedal repeatedly and use the handbrake gradually',
          nl: 'Pomp herhaaldelijk met het rempedaal en gebruik de handrem geleidelijk',
          ar: 'اضغط على دواسة الفرامل عدة مرات بشكل متكرر واستخدم فرامل اليد تدريجياً'
        }
      },
      {
        id: 'q-ep-13o2',
        text: {
          en: 'Accelerate to increase control',
          nl: 'Versnel om meer controle te krijgen',
          ar: 'زد السرعة لزيادة التحكم'
        }
      },
      {
        id: 'q-ep-13o3',
        text: {
          en: 'Shift to neutral and coast',
          nl: 'Schakel naar neutraal en laat uitrollen',
          ar: 'حوّل إلى الوضع المحايد واترك السيارة تنزلق'
        }
      }
    ],
    correctAnswerId: 'q-ep-13o1',
    explanation: {
      en: 'If brake pressure is lost, pump the brake pedal repeatedly to restore pressure. Use the handbrake gradually to slow the vehicle. Try to reach a safe stopping area and call for assistance.',
      nl: 'Als je geen remdruk meer hebt, pomp dan herhaaldelijk met het rempedaal om de remdruk terug te krijgen. Gebruik de handrem geleidelijk om de auto af te remmen. Probeer een veilige plek om te stoppen te bereiken en roep hulp in.',
      ar: 'إذا فقدت سيارتك ضغط الفرامل، اضغط على دواسة الفرامل عدة مرات لاستعادة الضغط. استخدم فرامل اليد تدريجياً لإبطاء السيارة. حاول الوصول إلى منطقة توقف آمنة واطلب المساعدة.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-14',
    text: {
      en: 'What should you do if your brakes fail completely while driving downhill?',
      nl: 'Wat moet je doen als je remmen volledig uitvallen tijdens het rijden op een helling?',
      ar: 'ماذا يجب أن تفعل إذا تعطلت الفرامل تماماً أثناء القيادة على منحدر؟'
    },
    options: [
      {
        id: 'q-ep-14o1',
        text: {
          en: 'Shift to a lower gear and use the handbrake gradually',
          nl: 'Schakel naar een lagere versnelling en gebruik de handrem geleidelijk',
          ar: 'غيّر إلى سرعة أقل واستخدم فرامل اليد تدريجياً'
        }
      },
      {
        id: 'q-ep-14o2',
        text: {
          en: 'Speed up to clear the slope',
          nl: 'Versnel om de helling snel te verlaten',
          ar: 'زد السرعة لتتجاوز المنحدر بسرعة'
        }
      },
      {
        id: 'q-ep-14o3',
        text: {
          en: 'Shift to neutral to reduce drag',
          nl: 'Schakel naar neutraal om de weerstand te verminderen',
          ar: 'حوّل إلى الوضع المحايد لتقليل مقاومة السحب'
        }
      }
    ],
    correctAnswerId: 'q-ep-14o1',
    explanation: {
      en: 'If brakes fail downhill, shift to a lower gear to use engine braking and apply the handbrake gradually. Never shift to neutral. Look for a safe place to slow down, such as an escape lane or safe area.',
      nl: 'Als je remmen uitvallen op een helling, schakel dan naar een lagere versnelling om motorremming te gebruiken en rem geleidelijk met de handrem. Schakel nooit naar neutraal. Zoek een veilige plek om af te remmen, zoals een uitwijkstrook of een veilige zone.',
      ar: 'إذا تعطلت الفرامل على منحدر، قم بتغيير السرعة إلى سرعة أقل لاستخدام الفرملة بالمحرك، ثم استخدم فرامل اليد تدريجياً. لا تحوّل أبداً إلى وضع المحايد. ابحث عن مكان آمن لإبطاء السيارة، مثل حارة/منطقة الهروب أو منطقة آمنة.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-15',
    text: {
      en: 'What should you do if your vehicle goes into a skid on a wet or icy road?',
      nl: 'Wat moet je doen als je voertuig in een slip raakt op een natte of ijzige weg?',
      ar: 'ماذا يجب أن تفعل إذا دخلت سيارتك في انزلاق على طريق مبلل أو مغطى بالثلج؟'
    },
    options: [
      {
        id: 'q-ep-15o1',
        text: {
          en: 'Brake hard to regain control',
          nl: 'Hard remmen om weer controle te krijgen',
          ar: 'اضغط على الفرامل بقوة لاستعادة السيطرة'
        }
      },
      {
        id: 'q-ep-15o2',
        text: {
          en: 'Steer in the direction you want the back to go and ease off the accelerator',
          nl: 'Stuur in de richting waarin je wilt dat de achterkant heen gaat en laat het gaspedaal los',
          ar: 'وجّه المقود في اتجاه تريد أن تتحرك به مؤخرة السيارة وخفّف الضغط على دواسة الوقود'
        }
      },
      {
        id: 'q-ep-15o3',
        text: {
          en: 'Accelerate to straighten out',
          nl: 'Versnel om weer rechtuit te rijden',
          ar: 'زد السرعة لتستقيم السيارة'
        }
      }
    ],
    correctAnswerId: 'q-ep-15o2',
    explanation: {
      en: 'In a skid, remain calm and steer in the direction you want the back of the vehicle to go. Ease off the accelerator but do not brake suddenly. Once control is regained, continue carefully.',
      nl: 'Bij slip: blijf kalm en stuur in de richting waarin je wilt dat de achterkant van de auto heen gaat. Laat het gaspedaal los, maar rem niet plotseling. Als je weer controle hebt, rijd dan voorzichtig verder.',
      ar: 'عند الانزلاق، حافظ على هدوئك ووجّه السيارة في اتجاه تريد أن تتحرك به مؤخرة السيارة. خفّف الضغط على الوقود لكن لا تضغط على الفرامل فجأة. بعد استعادة السيطرة، أكمل القيادة بحذر.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-16',
    text: {
      en: 'What should you do if your steering fails while driving?',
      nl: 'Wat moet je doen als je stuur uitvalt tijdens het rijden?',
      ar: 'ماذا يجب أن تفعل إذا تعطل نظام التوجيه (المقود) أثناء القيادة؟'
    },
    options: [
      {
        id: 'q-ep-16o1',
        text: {
          en: 'Continue driving and try to steer with the wheel',
          nl: 'Blijf rijden en probeer met het stuur te sturen',
          ar: 'تابع القيادة وحاول التوجيه بواسطة المقود'
        }
      },
      {
        id: 'q-ep-16o2',
        text: {
          en: 'Pull over safely using the handbrake and call for assistance',
          nl: 'Ga veilig aan de kant met de handrem en roep hulp in',
          ar: 'اسحب إلى جانب الطريق بأمان باستخدام فرامل اليد واطلب المساعدة'
        }
      },
      {
        id: 'q-ep-16o3',
        text: {
          en: 'Accelerate to gain control',
          nl: 'Versnel om controle te krijgen',
          ar: 'زد السرعة لاكتساب السيطرة'
        }
      }
    ],
    correctAnswerId: 'q-ep-16o2',
    explanation: {
      en: 'If steering fails, pull over safely using the handbrake to slow down gradually. Use gentle movements and try to avoid sudden changes. Call for assistance immediately.',
      nl: 'Als het stuur uitvalt, ga dan veilig aan de kant met de handrem om geleidelijk af te remmen. Gebruik rustige bewegingen en vermijd plotselinge veranderingen. Bel direct om hulp.',
      ar: 'إذا تعطل المقود، اسحب إلى جانب الطريق بأمان باستخدام فرامل اليد لإبطاء السيارة تدريجياً. استخدم حركات هادئة وحاول تجنب أي تغييرات مفاجئة. اطلب المساعدة فوراً.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-17',
    text: {
      en: 'What should you do if you have a flat tire while driving at high speed?',
      nl: 'Wat moet je doen als je een lekke band hebt terwijl je met hoge snelheid rijdt?',
      ar: 'ماذا يجب أن تفعل إذا أصيبت سيارتك بإطار مثقوب أثناء القيادة بسرعة عالية؟'
    },
    options: [
      {
        id: 'q-ep-17o1',
        text: {
          en: 'Brake hard immediately',
          nl: 'Rem onmiddellijk hard',
          ar: 'اضغط على الفرامل بقوة فوراً'
        }
      },
      {
        id: 'q-ep-17o2',
        text: {
          en: 'Reduce speed gradually, maintain steering control, and move to the side of the road',
          nl: 'Verminder geleidelijk de snelheid, behoud stuurcontrole en ga aan de kant van de weg',
          ar: 'قلل السرعة تدريجياً مع الحفاظ على التحكم بالمقود وانتقل إلى جانب الطريق'
        }
      },
      {
        id: 'q-ep-17o3',
        text: {
          en: 'Swerve to avoid the tire',
          nl: 'Zwenk om de band te vermijden',
          ar: 'حاول التحرف لتجنب الإطار'
        }
      }
    ],
    correctAnswerId: 'q-ep-17o2',
    explanation: {
      en: 'With a flat tire, reduce speed gradually and maintain firm steering control. Do not brake hard as this can cause loss of control. Move safely to the side of the road before stopping.',
      nl: 'Bij een lekke band: verminder geleidelijk de snelheid en behoud een stevige controle over het stuur. Rem niet hard; dat kan leiden tot verlies van controle. Ga veilig aan de kant van de weg voordat je stopt.',
      ar: 'عند ثقب الإطار، قلل السرعة تدريجياً مع الحفاظ على تحكم ثابت بالمقود. لا تضغط على الفرامل بقوة لأن ذلك قد يؤدي إلى فقدان السيطرة. انتقل بأمان إلى جانب الطريق قبل التوقف.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-18',
    text: {
      en: 'What is the proper procedure after a minor traffic accident if no one is injured?',
      nl: 'Wat is de juiste procedure na een licht verkeersongeval als er niemand gewond is?',
      ar: 'ما الإجراء الصحيح بعد حادث مروري بسيط إذا لم يُصب أحد بأذى؟'
    },
    options: [
      {
        id: 'q-ep-18o1',
        text: {
          en: 'Exchange details and insurance information',
          nl: 'Wissel gegevens en verzekeringsinformatie uit',
          ar: 'تبادل بيانات الاتصال ومعلومات التأمين'
        }
      },
      {
        id: 'q-ep-18o2',
        text: {
          en: 'Take photos of vehicle damage and location',
          nl: 'Maak foto’s van voertuigschade en locatie',
          ar: 'التقط صوراً لأضرار المركبات ومكان الحادث'
        }
      },
      {
        id: 'q-ep-18o3',
        text: {
          en: 'All of the above',
          nl: 'Alle bovenstaande',
          ar: 'كل ما سبق'
        }
      }
    ],
    correctAnswerId: 'q-ep-18o3',
    explanation: {
      en: 'After a minor accident with no injuries, exchange names, addresses, phone numbers, and insurance details. Take photos of all vehicle damage and the accident location. Report to your insurance company.',
      nl: 'Na een licht ongeval zonder letsel wissel je namen, adressen, telefoonnummers en verzekeringsgegevens uit. Maak foto’s van alle voertuigschade en de plaats van het ongeval. Meld het bij je verzekeringsmaatschappij.',
      ar: 'بعد حادث بسيط دون إصابات، تبادل الأسماء والعناوين وأرقام الهواتف وتفاصيل التأمين. التقط صوراً لجميع أضرار المركبات وموقع الحادث. ثم أبلغ شركة التأمين الخاصة بك.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-19',
    text: {
      en: 'What should you do if a pedestrian is hit by your vehicle?',
      nl: 'Wat moet je doen als een voetganger door jouw voertuig wordt aangereden?',
      ar: 'ماذا يجب أن تفعل إذا صدمَت مركبتك أحد المشاة؟'
    },
    options: [
      {
        id: 'q-ep-19o1',
        text: {
          en: 'Leave the scene quickly',
          nl: 'Verlaat de plaats snel',
          ar: 'غادر مكان الحادث بسرعة'
        }
      },
      {
        id: 'q-ep-19o2',
        text: {
          en: 'Stop immediately, provide assistance, and call emergency services',
          nl: 'Stop onmiddellijk, help en bel de hulpdiensten',
          ar: 'توقف فوراً وقدم المساعدة واتصل بخدمات الطوارئ'
        }
      },
      {
        id: 'q-ep-19o3',
        text: {
          en: 'Move the injured person to the side of the road',
          nl: 'Verplaats het gewonde slachtoffer naar de kant van de weg',
          ar: 'انقل الشخص المصاب إلى جانب الطريق'
        }
      }
    ],
    correctAnswerId: 'q-ep-19o2',
    explanation: {
      en: 'If you hit a pedestrian, stop immediately and call emergency services (112). Provide assistance if safe to do so but do not move the injured person unless they are in immediate danger. Stay at the scene.',
      nl: 'Als je een voetganger aanrijdt, stop dan onmiddellijk en bel de hulpdiensten (112). Help waar dat veilig is, maar verplaats het slachtoffer niet tenzij er direct gevaar is. Blijf op de plaats.',
      ar: 'إذا صدمت أحد المشاة، توقف فوراً واتصل بخدمات الطوارئ (112). قدم المساعدة إذا كان ذلك آمناً، لكن لا تحرك المصاب إلا إذا كان في خطر مباشر. ابق في مكان الحادث.'
    },
    subject: 'Emergency Procedures'
  },
  {
    id: 'q-ep-20',
    text: {
      en: 'What is the emergency number to call in the Netherlands for medical, fire, or police emergencies?',
      nl: 'Wat is het noodnummer om in Nederland te bellen voor medische, brand- of politie-noodsituaties?',
      ar: 'ما رقم الطوارئ الذي يجب الاتصال به في هولندا لحالات الطوارئ الطبية أو الحريق أو الشرطة؟'
    },
    options: [
      {
        id: 'q-ep-20o1',
        text: {
          en: '911',
          nl: '911',
          ar: '911'
        }
      },
      {
        id: 'q-ep-20o2',
        text: {
          en: '112',
          nl: '112',
          ar: '112'
        }
      },
      {
        id: 'q-ep-20o3',
        text: {
          en: '999',
          nl: '999',
          ar: '999'
        }
      }
    ],
    correctAnswerId: 'q-ep-20o2',
    explanation: {
      en: 'The universal emergency number in the Netherlands is 112. This number connects to police, fire, ambulance, and other emergency services. You can call 112 from any phone, including mobile phones.',
      nl: 'Het algemene noodnummer in Nederland is 112. Dit nummer verbindt je met politie, brandweer, ambulance en andere hulpdiensten. Je kunt 112 bellen vanaf elke telefoon, ook vanaf mobiele telefoons.',
      ar: 'رقم الطوارئ الموحد في هولندا هو 112. يربطك هذا الرقم بالشرطة والإطفاء والإسعاف وخدمات الطوارئ الأخرى. يمكنك الاتصال بـ 112 من أي هاتف، بما في ذلك الهواتف المحمولة.'
    },
    subject: 'Emergency Procedures'
  }
];

























